import React, { useState } from 'react';
import axios from 'axios';
import { Mail, AlertCircle, CheckCircle, Loader } from 'lucide-react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://touchdownleague.com/api';

function EmailNotVerifiedBanner({ email, onClose }) {
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const handleResendEmail = async () => {
        setLoading(true);
        setError('');

        try {
            await axios.post(`${API_BASE_URL}/auth/resend-verification`, { email });
            setSent(true);
            setTimeout(() => {
                setSent(false);
            }, 5000);
        } catch (err) {
            setError(err.response?.data?.error || 'Erreur lors de l\'envoi de l\'email');
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                        <h3 className="font-semibold text-green-800">Email envoyé !</h3>
                        <p className="text-sm text-green-700 mt-1">
                            Un nouvel email de vérification a été envoyé à <strong>{email}</strong>.
                            Vérifiez votre boîte de réception.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
            <div className="flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                <div className="flex-1">
                    <h3 className="font-semibold text-yellow-800">Email non vérifié</h3>
                    <p className="text-sm text-yellow-700 mt-1">
                        Vous devez vérifier votre adresse email avant de pouvoir vous connecter.
                        Consultez votre boîte de réception (<strong>{email}</strong>) et cliquez sur le lien de vérification.
                    </p>
                    {error && (
                        <p className="text-sm text-red-600 mt-2">{error}</p>
                    )}
                    <div className="flex gap-2 mt-3">
                        <button
                            onClick={handleResendEmail}
                            disabled={loading}
                            className="flex items-center gap-2 px-4 py-2 bg-yellow-600 text-white text-sm rounded-lg hover:bg-yellow-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <>
                                    <Loader className="w-4 h-4 animate-spin" />
                                    Envoi...
                                </>
                            ) : (
                                <>
                                    <Mail className="w-4 h-4" />
                                    Renvoyer l'email
                                </>
                            )}
                        </button>
                        {onClose && (
                            <button
                                onClick={onClose}
                                className="px-4 py-2 bg-gray-200 text-gray-700 text-sm rounded-lg hover:bg-gray-300 transition-colors"
                            >
                                Fermer
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmailNotVerifiedBanner;
